var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isStoreLayout)?_c('StoreLayout',[_c('router-view')],1):_c('div',[_c('router-view')],1)],1),_c('Toast',{attrs:{"show":_vm.toast.show,"message":_vm.toast.message,"type":_vm.toast.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }